import Waypoint from 'waypoints';

export function TransparentNav(elem) {
  const marketingNav = document.querySelector('.marketing-nav');

  new Waypoint({
    element: elem,
    offset: () => -elem.clientHeight + marketingNav.clientHeight,
    handler: (dir) => {
      if (dir === 'down') {
        marketingNav.classList.add('marketing-nav--solid');
      } else {
        marketingNav.classList.remove('marketing-nav--solid');
      }
    },
  });
}
